<template>
  <div class="file-uploader">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
        <b-switch v-model="overwrite">Overwrite?</b-switch>
      </header>
      <div class="modal-card-body">
        <section v-if="uploading" class="section">
          <div class="content has-text-centered">
            <p>
              <b-icon icon="upload" size="is-large" />
            </p>
            <progress
              class="progress is-small"
              :value="uploadProgress"
              max="100"
            />
            <p>Uploading: {{ uploadProgress }} %</p>
          </div>
        </section>
        <b-field v-else custom-class="is-full-width">
          <b-upload
            v-model="files"
            drag-drop
            expanded
            :accept="accept"
            v-bind="$attrs"
            @input="fileUploadHandler"
          >
            <slot>
              <section class="section">
                <div class="content has-text-centered">
                  <p>
                    <b-icon icon="upload" size="is-large" />
                  </p>
                  <p>Drop your file here or click to upload</p>
                </div>
              </section>
            </slot>
          </b-upload>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import camelCase from 'lodash/camelCase';

export function openFileUploadModal(parent, props) {
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: FileUploadModal,
      hasModalCard: true,
      events: {
        input: resolve
      },
      props,
      onCancel: reject
    });
  });
}

const FileUploadModal = {
  props: {
    resourceState: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: 'Upload File'
    },
    accept: {
      type: String,
      default: '.pdf'
    },
    pathPrefix: {
      type: Function,
      default: () => 'customUploads'
    }
  },
  data() {
    return {
      files: [],
      overwrite: false
    };
  },
  computed: {
    state() {
      return this.$store.state[this.resourceState];
    },
    uploadProgress() {
      return this.state[this.getFieldPrefixedName('upload_progress')].toFixed(
        2
      );
    },
    uploading() {
      return this.state[this.getFieldPrefixedName('uploading')];
    },
    uploadURL() {
      return this.state[this.getFieldPrefixedName('uploadURL')];
    },
    uploadError() {
      return this.state[this.getFieldPrefixedName('uploadError')];
    }
  },
  methods: {
    async uploadFile(payload) {
      return await this.$store.dispatch(
        `${this.resourceState}/${camelCase(
          `upload_${this.resourceState}${
            this.fieldName ? `_${this.fieldName}` : ''
          }`
        )}`,
        payload
      );
    },
    getFieldPrefixedName(name) {
      return this.fieldName ? camelCase(`${this.fieldName}_${name}`) : name;
    },
    async fileUploadHandler(file) {
      try {
        await this.uploadFile({
          file,
          overwrite: this.overwrite,
          pathPrefix: this.pathPrefix(file)
        });
        this.$buefy.toast.open({
          message: 'File Upload Completed!',
          type: 'is-success'
        });
        this.$emit('input', this.uploadURL);
        this.$emit('close');
      } catch (e) {
        this.$buefy.toast.open({
          message: this.UploadError || e || 'File Upload Failed!',
          type: 'is-danger'
        });
        this.$emit('close');
      } finally {
        this.reset();
      }
    },
    reset() {
      this.files = [];
    }
  }
};

export default FileUploadModal;
</script>

<style lang="scss" scoped>
.file-uploader {
  .modal-card {
    .modal-card-title {
      margin-right: 2rem;
    }
    .modal-card-body {
      .upload {
        display: block;
        .upload-draggable {
          display: flex;
          min-height: 40vh;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
}
</style>
